import { PlusIcon } from "@radix-ui/react-icons";
import { toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, HTMLAttributes } from "react";

const AddItemButton: FC<HTMLAttributes<HTMLDivElement>> = ({ className, onClick }) => {
  return (
    <div
      className={cx(
        "flex items-center justify-center",
        "rounded-lg border border-dashed border-primary dark:border-primary/50",
        "hover:bg-primary/20",
        toolkitCx.layout.spacing.both.md,
        toolkitCx.recipes.scaleWhenActive,
        toolkitCx.layout.transition.default,
        className
      )}
      onClick={onClick}
      role="button"
    >
      <PlusIcon className="h-3 w-3" />
    </div>
  );
};

export default AddItemButton;
